import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import onClickOutside from 'react-onclickoutside';

import { translate } from '../../commons/localize';
import { MdAddCircleOutline, MdRemoveCircleOutline } from 'react-icons/md';

import SelectorDropDown from '../SelectorDropDown';

class ChildsForm extends React.Component {
  static propTypes = {
    defaultPaxes: PropTypes.number,
    defaultAges: PropTypes.arrayOf(PropTypes.number),
    isOpen: PropTypes.bool,
    maxPaxes: PropTypes.number,
    agesOptions: PropTypes.arrayOf(PropTypes.object),
    handleFormData: PropTypes.func,
    closeForm: PropTypes.func
  }

  static defaultProps = {
    defaultPaxes: 0,
    defaultAges: [],
    isOpen: false,
    maxPaxes: 0,
    agesOptions: [],
    handleFormData: () => {},
    closeForm: () => {}
  }

  constructor(props){
    super(props)
    this.state = {
      currentPaxes: this.props.defaultPaxes,
      agesList: this.props.defaultAges.map((age, index) => ({ id: (index + 1), age })),
      modified: false
    }
  }

  componentDidUpdate(prevProps) {
    const { maxPaxes, defaultPaxes, defaultAges } = this.props;

    if (prevProps.maxPaxes === maxPaxes) {
      const { defaultPaxes: oldDefaultPaxes, defaultAges: oldDefaultAges} = prevProps;

      if (defaultPaxes === oldDefaultPaxes && defaultAges === oldDefaultAges) return;

      this.setStateOnly(defaultPaxes, defaultAges);

      return;
    }

    this.setStateOnly(defaultPaxes, defaultAges);
  }

  setStateOnly = (defaultPaxes, defaultAges) => {
    this.setState({
      currentPaxes: defaultPaxes,
      agesList: defaultAges.map((age, index) => ({ id: (index + 1), age })),
      modified: false
    });
  }

  addPax = () => {
    const { currentPaxes, agesList } = this.state;
    const { agesOptions } = this.props;

    let defaultAge = 0;
    if (agesOptions && agesOptions[0] && agesOptions[0].value) {
      defaultAge = agesOptions[0].value;
    }

    const newObj = {
      id: (currentPaxes + 1),
      age: defaultAge
    };

    this.setState({
      currentPaxes: currentPaxes + 1,
      agesList: [...agesList, newObj],
      modified: true
    }, () => {
      this.sendInfoData(false);
    });
  }

  erasePax = () => {
    const { currentPaxes, agesList } = this.state;

    this.setState({
      currentPaxes: currentPaxes - 1,
      agesList: agesList.filter((obj) => obj.id !== (currentPaxes)),
      modified: true
    }, () => {
      this.sendInfoData(false);
    });
  }

  updatePaxAge = (id, age) => {
    const { agesList } = this.state;

    const modifiedList = agesList.map((obj) => {
      if (obj.id !== id) return obj;

      return { ...obj, age }
    });

    this.setState({
      agesList: modifiedList,
      modified: true
    }, () => {
      this.sendInfoData(false);
    });
  }

  handleClickOutside = () => {
    const { modified } = this.state;

    if (!modified) {
      this.props.closeForm();
      return;
    }

    this.setState({ modified: false }, () => {
      this.sendInfoData(true);
    });
  }

  sendInfoData = (updateData) => {
    const { currentPaxes, agesList } = this.state;

    this.props.handleFormData(currentPaxes, agesList.map(obj => obj.age), updateData);
  }

  render() {
    const { currentPaxes, agesList } = this.state;
    const { isOpen, maxPaxes, agesOptions } = this.props;

    const showAgesContainer = (agesList.length > 0);
    const customAddClass = `${(currentPaxes === maxPaxes) ? 'dirty-prevent' : ''}`
    const customRemoveClass = `${(currentPaxes === 0) ? 'dirty-prevent' : ''}`

    return (
      <>
        {isOpen &&
          <Container className="childs-form__container">
            <Row className="auto-margin form__header">
              <Col sm="auto" className="no-padding-left">
                <label className="title">{translate('ninos')}</label>
              </Col>
              <Col sm="auto" className="no-padding">
                <MdRemoveCircleOutline
                  className={customRemoveClass}
                  data-test-id="remove-childs-bttn"
                  onClick={this.erasePax}
                />
                <label className="data-value" data-test-id="childs-data-value">
                  {currentPaxes}
                </label>
                <MdAddCircleOutline
                  className={customAddClass}
                  data-test-id="add-childs-bttn"
                  onClick={this.addPax}
                />
              </Col>
            </Row>
            {showAgesContainer && (
              <Row className="auto-margin form__data">
                <label className="title">{translate('edad_ninos')}</label>
                {agesList.map((obj) => {
                  const { id, age } = obj;

                  const customKey = `PAX_AGE_${id}`;
                  const customDataTestLabel = `pax-${id}-age-selector`;

                  return (
                    <Col sm="12" className="no-padding" key={customKey}>
                      <SelectorDropDown
                        defaultValue={age}
                        dataTestLabel={customDataTestLabel}
                        options={agesOptions}
                        handleSelectOption={(value) => { this.updatePaxAge(id, value) }}
                        isSearchable={true}
                      />
                    </Col>
                  )
                })}
              </Row>
            )}
          </Container>
        }
      </>
    );
  }
}

export default onClickOutside(ChildsForm);
